(function AdzukiClientLink($, Adzuki)
{
	'use strict';

	const component = {
		emits : ['close-client-link', 'client-unlinked'],
		inject: {
			openToast: {
				default: () => undefined
			},
			openAlert: {
				default: () => undefined
			},
		},
		props: {
			media: {
				type: Object,
			}
		},
		data() {
			return {
				clientForm: {
					source    : 'all',
					searchTerm: '',
				},
				fetchClientList: null,
				selectedClients: [],
				clientList     : {},
				sources        : {
					all           : 'Search All Recipient Types',
					client        : 'Search Clients',
					'cp-insight'  : 'Search CP Insights Codes',
					group         : 'Search Groups',
					household     : 'Search Households',
					reservation   : 'Search Reservations',
					segment       : 'Search Segments',
					'smart-select': 'Search Smart Select Lists',
					source        : 'Search Sources'
				},
				showSuggestions: false,
				linkedClients  : [],
				loading        : false
			};
		},
		template: `
			  <div class="client-link-form row mt-3">
				  <div class="col">
				    <h4>Link Clients</h4>
					<div class="row">
					  <div class="form-input-group w-50">
						<label for="source" class="form-label">Client Type</label>
						<select name="source" id="source" class="form-select" v-model="clientForm.source">
						  <option v-for="(source, key) in sources" :key="key" :value="key">{{ source }}</option>
						</select>
					  </div>
					  <div class="form-input-group w-50">
						<div class="form-group position-relative">
						  <label class="form-label">Search Term</label>
						  <input
							class="form-control"
							:class="{ 'field-ajax-spinner': loading }"
							id="searchTerm"
							type="text"
							name="searchTerm"
							autocomplete="off"
							@input="onSearchTermInput($event.target.value)"
							v-model="clientForm.searchTerm"
						  />
						  <div
							  class="position-absolute w-100 top-100 start-0 z-2"
							  v-if="showSuggestions"
						  >
							<div class="client-suggestions border rounded bg-white shadow">
							  <ul class="list-group">
								<li
									v-if="clientList.length > 0"
									v-for="client in clientList"
									:key="client.id"
									@click="selectClient(client)"
									class="client-item list-group-item text-break pointer"
								>
								  {{ client.name }}
								</li>
							  </ul>
							</div>
						  </div>
						</div>
					  </div>
					</div>
					<div class="row mt-2" v-if="selectedClients.length >= 1">
					  <div class="col">
						  <span
							  class="badge bg-primary me-1 p-2 mt-1 d-inline-block pointer"
							  v-for="(selectedClient, key) in selectedClients"
						  >
							<i class="fas fa-times" @click="clearClient"></i>
							{{selectedClient.name}}
						  </span>
					  </div>
					</div>
					<div class="row mt-2" v-if="linkedClients.length >= 1">
					  <div class="col">
						  <span
							  class="badge bg-primary me-1 p-2 mt-1 d-inline-block pointer"
							  v-for="(linkedClient, key) in linkedClients"
						  >
							<i class="fas fa-times" @click="unlinkClient(linkedClient)"></i>
							{{linkedClient.client_name}}
						  </span>
					  </div>
					</div>
					<div class="row mt-3">
					  <div class="form-input-group">
						  <button 
							  class="btn btn-primary btn-sm"
							  :disabled="selectedClients.length < 1" 
							  @click="linkClient"
						  >
							Link Client<span v-if="selectedClients.length > 1">s</span>
						  </button>
					  </div>
					</div>
				  </div>
			  </div>
		`,
		created() {
			this.fetchClientList = Adzuki.Debounce((searchTerm) => {
				const term = String(searchTerm || '').trim();

				if (!term) {
					this.clientList = {};
					this.showSuggestions = false;
					this.loading = false;

					return;
				}

				const uri = this.$baseUri + '/Searches/recipient/' + this.clientForm.source + '/' + encodeURIComponent(term) + '/0/0/1';

				this.loading = true;

				fetch(uri)
					.then(response => response.json())
					.then(data => {
						this.clientList = data;
						this.showSuggestions = true;
					})
					.catch(error => {
						console.error('Error fetching recipients:', error);
					})
					.finally(() => {
						this.loading = false;
					});
			}, 300);
		},
		methods: {
			onSearchTermInput(searchTerm) {
				this.fetchClientList(searchTerm);
			},
			resetStateForMedia(media) {
				this.selectedClients = [];
				this.clientList = {};
				this.showSuggestions = false;

				this.clientForm = {
					source    : 'all',
					searchTerm: ''
				};

				this.linkedClients = (media && media.clients) ? media.clients : [];
			},
			selectClient(client) {
				this.selectedClients.push(client);
				this.showSuggestions       = false;
				this.clientList            = {};
				this.clientForm.searchTerm = '';
			},
			linkClient() {
				let formData = new FormData();

				formData.append('media_id', this.media.id);
				formData.append('recipients', JSON.stringify(this.selectedClients));

				fetch(this.$baseUri + '/Media/linkClient/', {
					method: 'POST',
					body  : formData,
				})
					.then(response => response.json())
					.then(data => {
						this.openAlert('success', 'Success', data.message);
						this.clearClient();
					})
					.catch(err => {
						this.openAlert('error', 'Error', err.message);
					});
			},
			unlinkClient(client) {
				let client_id = client.id;
				let media_id  = this.media.id;

				const url = `${this.$baseUri}/Media/unlinkClient/${media_id}/${client_id}/`;

				fetch(url)
					.then(response => {
						if (!response.ok) {
							throw new Error(`${response.statusText}`);
						}
						return response.json();
					})
					.then(data => {
						this.linkedClients = this.linkedClients.filter(c => Number(c.id) !== Number(client_id));
						this.openAlert('success', 'Success', data.message);

						const eventData = {
							client_id: client_id,
							media_id : media_id
						};

						this.$emit('client-unlinked', eventData);
					})
					.catch(error => {
						this.openAlert('error', 'Error', 'An error occurred while unlinking clients: ' + error.message);
					});
			},
			clearClient() {
				this.selectedClients = [];
				this.clientForm      = {};
				this.clientList = {};
			}
		},
		watch: {
			media: {
				immediate: true,
				handler(newMedia) {
					this.resetStateForMedia(newMedia);
				}
			}
		}
	};


	Adzuki.VueComponents.AdzukiClientLink = component;
}(jQuery, window.Adzuki || {}));
